import {ApiExecutorEffect, ApiInterceptors, ApiRequestDs, ApiResponse, ClearInterceptorsArg, IApiExecutor,} from "./type-declarations";

/**
 * The interface that houses all the available api calls related to this application.
 */
class ApiService {

    /**
     * The executor of this api responsible for handling the api call themselves.
     * @private
     */
    protected static _executor: IApiExecutor;

    /**
     * The executor of this api responsible for handling the api call themselves.
     */
    public static get executor(): IApiExecutor {
        return this._executor;
    }

    /**
     * Sets the executor of this api responsible for handling the api call themselves.
     * @param value    The executor of this api responsible for handling the api call themselves.
     */
    public static set executor(value: IApiExecutor) {
        this._executor = value;
    }

    /**
     * Injects the given effects to the API executor.
     * @param effects   The effects to be injected.
     */
    public static injectEffects(effects: Array<ApiExecutorEffect>): void {
        return this._executor.injectEffects(effects);
    }

    /**
     * Clears all the effects that are injected.
     */
    public static clearEffects(): void {
        return this._executor.clearEffects();
    }

    /**
     * Injects api interceptors to the axios instance used in this interface.
     * @param interceptors
     */
    public static injectInterceptors(interceptors: Partial<ApiInterceptors>): void {
        return this._executor.injectInterceptors(interceptors);
    }

    /**
     * Clears all the interceptors that are injected.
     * @param arg           The arguments to clear the interceptors.
     */
    public static clearInterceptors(arg?: ClearInterceptorsArg): void {
        return this._executor.clearInterceptors(arg);
    }


    // ---------------------------------------- API CALLS ---------------------------------------

    /**
     * Executes the given request and returns the response.
     * @param request   The request to be executed.
     */
    public static async execute<T>(request: ApiRequestDs): ApiResponse<T> {
        return await this.executor.execute(request);
    }

}

/**
 * The controller that is used to invoke its api calls.
 */
export abstract class ApiServiceController {

    /**
     * Creates a new instance of the ApiServiceController.
     * @param executor    The executor that will be used to execute the api calls.
     */
    protected constructor(protected executor: IApiExecutor | undefined) {
    }
}


export * from './type-declarations';
export {default as ApiExecutor} from './executor';
export default ApiService;
